import { PlanItemTypeEnum } from '../../Enum/PlanItemTypeEnum';
import BaseEntity from '../BaseEntity.model';
import { CreatedBy } from '../Shared/CreatedBy.model';

export default interface IPlanItem extends BaseEntity {
    Type: PlanItemTypeEnum;
    Name: string;
    Note: string;
    Phone: string;
    IsCareCircle: boolean;
    CreatedBy: CreatedBy;
    CreatedAt: string;
    UpdatedBy: CreatedBy;
    UpdatedAt: string;
}

export class PlanItem implements IPlanItem {
    Id: string;
    Type: PlanItemTypeEnum;
    Name: string;
    Note: string;
    Phone: string;
    IsCareCircle: boolean;
    CreatedBy: CreatedBy;
    CreatedAt: string;
    UpdatedBy: CreatedBy;
    UpdatedAt: string;

    constructor() {
        this.Id = '';
        this.Type = PlanItemTypeEnum.Person;
        this.Name = '';
        this.Note = '';
        this.Phone = '';
        this.IsCareCircle = false;
    }
}
